import useSWR from 'swr';

import { SWR_GLOBAL_CONFIG } from '~/api/_constant';
import { request } from '~/api/_utils/request';

import { ApiChallengeShow } from '../[id]/get-type';

const PATH = '/v1/challenges/intilaq';

export async function apiGetV1IntilaqChallenges() {
  const { challenges } = await request.GET<{ challenges: ApiChallengeShow[] }>(PATH);
  return challenges;
}

export function useSWRV1IntilaqChallenges() {
  const swr = useSWR(PATH, apiGetV1IntilaqChallenges, SWR_GLOBAL_CONFIG);
  return { ...swr, challenges: swr.data };
}
